import { action, computed, observable, reaction } from 'mobx';
import { emit, events } from 'elc-service-bus';
import { ContinueAsGuestUseCase } from '../use-cases/ContinueAsGuestUseCase';
import { GuestRepository } from '../repositories/GuestRepository';
import { ViewController } from 'elc-service';
import { IFormStore } from '../domain/entities/IFormStore';
import { IGuestFormValues } from '../domain/entities/IGuestFormValues';
import { createGuestFormStore } from '../domain/entities/GuestFormStoreFactory';

export interface IGuestFormViewControllerConfig {
    guestRepository: GuestRepository;
}

export class GuestFormViewController extends ViewController {
    private guestRepository: GuestRepository;
    @observable private formStore: IFormStore<IGuestFormValues> | null;

    constructor(config: IGuestFormViewControllerConfig) {
        super();

        this.guestRepository = config.guestRepository;

        reaction(
            () => this.isValid,
            () => {
                emit(events.GUEST_FORM_VALIDITY_CHANGED, { isValid: this.isValid });
            }
        );
    }

    @action
    public loaded = async () => {
        this.isLoading = true;

        const guestUser = await this.guestRepository.getGuestUser();
        this.formStore = await createGuestFormStore();
        this.formStore.values.email = guestUser.email;

        this.isLoading = false;
    };

    @computed
    public get data() {
        return {
            email: this.email,
            isValid: this.isValid,
            formStore: this.formStore
        };
    }

    @action
    public continueAsGuest = async () => {
        const continueAsGuestUseCase = new ContinueAsGuestUseCase(this.guestRepository, this.email);
        await continueAsGuestUseCase.execute();
    };

    @computed
    private get isValid() {
        return this.formStore ? this.formStore.isValid : false;
    }

    @computed
    private get email() {
        return this.formStore ? this.formStore.values.email : '';
    }
}
